import Vue from 'vue';
import App from './App.vue';
import './services/cartxMonitor';
import router from './router';
import store from './store';
import * as Echart from 'echarts';
import '@/plugins';
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.js';
// add new rewrite element-ui scoped By V.C
import './assets/css/reset.scss';
import './assets/font/index.css';
import { LogJsError } from './services/cartxLog';
import './services/longtask';
import { monitor, MonitorEvent } from './services/monitor';
// 导入全局点击事件监控插件
import GlobalTrackingPlugin from './plugins/globalTracking';

// 注册全局点击事件监控插件
Vue.use(GlobalTrackingPlugin);

router.afterEach((to, from) => {
  monitor({
    event: MonitorEvent.PageView,
    data: {
      path: to.fullPath,
      from: from.fullPath,
    }
  });
});

Vue.config.errorHandler = (err:Error, vm: Vue, info:string) => {
  // console.log('err', err);
  if (err.stack || err.message) {
    LogJsError({
      em:err?.message || `${err?.toString?.()}`,
      es:err?.stack,
      type:'vueerror',
    });
  }
}
Vue.config.productionTip = false;
Vue.prototype.$echarts = Echart;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
console.log('version: ' + process.env.VUE_APP_VERSION);
